import CityBg from "../assets/images/hereBg1.png";
import KitchenBg from "../assets/images/kitchenBg.png";
import Mascots from "../assets/images/heroMascots.png";
import MarikaCropped from "../assets/images/MarikaCropped.png";
import { BadgePlus, Dumbbell, Settings2, Soup } from "lucide-react";
import { FilterTypes } from "../types/product.types";
import type { LucideIcon } from "lucide-react";

export type HeroAction = "about" | "onboarding";

export type HeroSlideConfig = {
    id: string;
    titleKey: string;
    textKey: string;
    buttonKey: string;
    action: HeroAction;
    backgroundImage: string;
    mascotImage: string;
    mascotAlt: string;
    mascotClassName: "Mascots" | "MascotMarika";
};

export const heroSlides: HeroSlideConfig[] = [
    {
        id: "slide-1",
        titleKey: "home.hero.slide1.title",
        textKey: "home.hero.slide1.text",
        buttonKey: "home.hero.slide1.button",
        action: "about",
        backgroundImage: CityBg,
        mascotImage: Mascots,
        mascotAlt: "Hero mascots",
        mascotClassName: "Mascots",
    },
    {
        id: "slide-2",
        titleKey: "home.hero.slide2.title",
        textKey: "home.hero.slide2.text",
        buttonKey: "home.hero.slide2.button",
        action: "onboarding",
        backgroundImage: KitchenBg,
        mascotImage: MarikaCropped,
        mascotAlt: "Marika mascot",
        mascotClassName: "MascotMarika",
    },
    {
        id: "slide-3",
        titleKey: "home.hero.slide3.title",
        textKey: "home.hero.slide3.text",
        buttonKey: "home.hero.slide3.button",
        action: "about",
        backgroundImage: CityBg,
        mascotImage: Mascots,
        mascotAlt: "Hero mascots",
        mascotClassName: "Mascots",
    },
];

export type FilterCardConfig = {
    id: string;
    titleKey?: string;
    filterKey: FilterTypes;
    icon: LucideIcon;
    filled?: boolean;
    isSettings?: boolean;
};

export const filterCardConfigs: Record<"home" | "catalog", FilterCardConfig[]> = {
    home: [
        {
            id: "new",
            titleKey: "home.filters.basic.new",
            filterKey: "new",
            icon: BadgePlus,
            filled: false,
        },
        {
            id: "sales",
            titleKey: "home.filters.basic.products",
            filterKey: "sales",
            icon: Soup,
            filled: true,
        },
        {
            id: "activities",
            titleKey: "home.filters.basic.activities",
            filterKey: "activities",
            icon: Dumbbell,
        },
        {
            id: "settings",
            titleKey: "home.filters.basic.filters",
            filterKey: "",
            icon: Settings2,
            isSettings: true,
        },
    ],
    catalog: [
        {
            id: "sales",
            titleKey: "home.filters.basic.products",
            filterKey: "sales",
            icon: Soup,
            filled: true,
        },
        {
            id: "new",
            titleKey: "home.filters.basic.new",
            filterKey: "new",
            icon: BadgePlus,
            filled: false,
        },
        {
            id: "activities",
            titleKey: "home.filters.basic.activities",
            filterKey: "activities",
            icon: Dumbbell,
        },
        {
            id: "settings",
            filterKey: "",
            icon: Settings2,
            isSettings: true,
        },
    ],
};
